export class CountUpUtil {

  public static getDecimal(value: any) {
    const valueString = value && !isNaN(value) ? Number(value).toString() : '';
    const valueStringSplit = valueString.split('.');
    if (valueStringSplit.length === 2) {
      return valueStringSplit[1].length;
    } else {
      return 0;
    }
  }
}